import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import queryString from 'query-string';
import { Container } from 'reactstrap';

import {
  GET_INVENTORY_VIEW_EMPTY,
  GET_BOOKINGS_LIST,
  GET_BOOKINGS_LIST_EMPTY,
  GET_DASHBOARD_CONFIGURATION,
  GET_INVENTORY_VIEW,
  CREATE_CLIENT_V2_EMPTY,
  CREATE_AIRPORT_V2_EMPTY,
  CREATE_ZONES_V2_EMPTY,
  CREATE_VENDOR_V2_EMPTY,
  GET_FILTERS_LIST,
} from '../../../../../../../store/actions';
import { Loader } from '../../../../../../Common';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { Constant } from '../../../../../../Helpers/constant';
import Summary from './Components/Summary';
import Summary2 from '../../../Listing/Components/Summary';
import DataViews from './Components/Views';
import InventoryActions from './Components/Actions';
import Filter from './Components/Filter/Filter';

const InventoryList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const {
    skip = 1,
    limit = Constant.TABLE_PAGE_SIZE,
    name = '',
    type = '',
    appliedName = '',
    appliedType = '',
    nextNavigation = '',
    title = '',
  } = queryString.parse(location.search);

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [currentPageNumber, setCurrentPageNumber] = useState(Number(skip) - 1);
  const [rowsPerPage, setRowsPerPage] = useState(Number(limit));

  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);
  const [assignedToMeFilter, setAssignedToMeFilter] = useState(false);
  const [secondaryFiltersList, setSecondaryFiltersList] = useState(null);

  const [loading, setLoading] = useState(false);
  const [currentActiveBookingAction, setCurrentActiveBookingAction] = useState(null);

  const [isMultiSelectable, setIsMultiSelectable] = useState(false);
  const [shouldHaveClearSelection, setShouldHaveClearSelection] = useState(false);
  const [currentSelectedBooking, setCurrentSelectedBooking] = useState(null);

  const [workflowStateFilters, setWorkflowStateFilters] = useState([]);
  const [approvalRequestType, setApprovalRequestType] = useState({
    label: 'Booking Modification',
    value: 'modify_booking',
    action: 'reject_modify_booking',
  });

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { getDashboardConfiguration, getDashboardConfigurationLoading } = useSelector((state: any) => ({
    getDashboardConfiguration: state.GetDashboardConfiguration.data,
    getDashboardConfigurationLoading: state.GetDashboardConfiguration.loading,
  }));

  const { cardSummaryCount, cardSummaryCountLoading } = useSelector((state: any) => ({
    cardSummaryCount: state.GetCardSummary.data,
    cardSummaryCountLoading: state.GetCardSummary.loading,
  }));

  const { bookingsList, bookingsListLoading, inventoryView, inventoryViewLoading } = useSelector((state: any) => ({
    bookingsList: state?.GetBookingsList?.data,
    bookingsListLoading: state?.GetBookingsList?.loading,

    inventoryView: state?.GetInventoryView?.data,
    inventoryViewLoading: state?.GetInventoryView?.loading,
  }));

  const {
    createAirportV2,
    createAirportV2Loading,

    createClientV2,
    createClientV2Loading,

    createVendorV2,
    createVendorV2Loading,

    createZonesV2,
    createZonesV2Loading,

    updateAirportV2,
    updateAirportV2Loading,

    updateClientV2,
    updateClientV2Loading,

    updateVendorV2,
    updateVendorV2Loading,

    updateZonesV2,
    updateZonesV2Loading,

    validateZoneLoading,
  } = useSelector((state: any) => ({
    createAirportV2: state?.CreateAirportV2?.data,
    createAirportV2Loading: state?.CreateAirportV2?.loading,

    createClientV2: state?.CreateClientV2?.data,
    createClientV2Loading: state?.CreateClientV2?.loading,

    createVendorV2: state?.CreateVendorV2?.data,
    createVendorV2Loading: state?.CreateVendorV2?.loading,

    createZonesV2: state?.CreateZonesV2?.data,
    createZonesV2Loading: state?.CreateZonesV2?.loading,

    updateAirportV2: state?.UpdateAirportV2?.data,
    updateAirportV2Loading: state?.UpdateAirportV2?.loading,

    updateClientV2: state?.UpdateClientV2?.data,
    updateClientV2Loading: state?.UpdateClientV2?.loading,

    updateVendorV2: state?.UpdateVendorV2?.data,
    updateVendorV2Loading: state?.UpdateVendorV2?.loading,

    updateZonesV2: state?.UpdateZonesV2?.data,
    updateZonesV2Loading: state?.UpdateZonesV2?.loading,

    validateZoneLoading: state.ValidateZone?.loading,
  }));

  useEffect(() => {
    if (
      createAirportV2 !== null ||
      createClientV2 !== null ||
      createVendorV2 !== null ||
      createZonesV2 !== null ||
      updateAirportV2 !== null ||
      updateClientV2 !== null ||
      updateVendorV2 !== null ||
      updateZonesV2 !== null
    ) {
      if (isMultiSelectable) {
        setShouldHaveClearSelection(true);
        setTimeout(() => {
          setShouldHaveClearSelection(false);
        }, 1000);
      }

      if (skip == 1) {
        dispatch({
          type: GET_BOOKINGS_LIST,
          payload: {
            urlParams: {
              page_size: limit,
              page_index: Number(skip),
              card_name: appliedName ? appliedName : name,
              ...{ ...currentlyAppliedFilters, is_show_unassigned_bookings: assignedToMeFilter },
            },
            params: {
              card_type: appliedType ? appliedType : type,
            },
          },
        });
      } else updateURLParams({ skip: 1, limit: limit });

      dispatch({
        type: CREATE_AIRPORT_V2_EMPTY,
      });

      dispatch({
        type: CREATE_CLIENT_V2_EMPTY,
      });

      dispatch({
        type: CREATE_ZONES_V2_EMPTY,
      });

      dispatch({
        type: CREATE_VENDOR_V2_EMPTY,
      });

      dispatch({
        type: GET_INVENTORY_VIEW_EMPTY,
      });

      setCurrentSelectedBooking(null);
      setCurrentActiveBookingAction(null);
    }
  }, [createAirportV2, createClientV2, createZonesV2, createVendorV2, updateAirportV2, updateClientV2, updateZonesV2, updateVendorV2]);

  useEffect(() => {
    if (name !== `` && type !== ``) {
      dispatch({
        type: GET_BOOKINGS_LIST,
        payload: {
          urlParams: {
            page_size: limit,
            page_index: Number(skip),
            card_name: appliedName ? appliedName : name,
            ...{ ...currentlyAppliedFilters, is_show_unassigned_bookings: assignedToMeFilter },
          },
          params: {
            card_type: appliedType ? appliedType : type,
          },
        },
      });

      dispatch({
        type: GET_FILTERS_LIST,
        payload: {
          urlParams: {
            card_name: appliedName || name,
            card_type: appliedType || type,
          },
        },
      });
    }
  }, [skip, limit, currentlyAppliedFilters, name, appliedName, approvalRequestType, workflowStateFilters, assignedToMeFilter]);

  useEffect(() => {
    setCurrentPageNumber(Number(skip) - 1);
  }, [skip]);

  useEffect(() => {
    setRowsPerPage(Number(limit));
  }, [limit]);

  useEffect(() => {
    dispatch({
      type: GET_DASHBOARD_CONFIGURATION,
    });
  }, []);

  useEffect(() => {
    if (currentSelectedBooking?.length === 1) {
      dispatch({
        type: GET_INVENTORY_VIEW,
        payload: {
          urlParams: {
            id: currentSelectedBooking?.[0]?.id,
            card_name: name,
          },
        },
      });
    }
  }, [currentSelectedBooking]);

  useEffect(() => {
    return () => {
      dispatch({
        type: GET_INVENTORY_VIEW_EMPTY,
      });
      dispatch({
        type: GET_BOOKINGS_LIST_EMPTY,
      });
    };
  }, []);

  const updateURLParams = newParams => {
    const currentParams = queryString.parse(location.search);

    const updatedParams = {
      ...currentParams,
      ...newParams,
    };

    const newUrl = queryString.stringify(updatedParams);
    history.push({
      pathname: location.pathname,
      search: `?${newUrl}`,
    });
  };

  const filterSubmitHandler = (filters = currentlyAppliedFilters) => {
    setCurrentlyAppliedFilters(filters);
    setCurrentActiveBookingAction(null);
    setCurrentSelectedBooking(null);
    dispatch({
      type: GET_INVENTORY_VIEW_EMPTY,
    });
    updateURLParams({ skip: 1, limit: limit });
  };

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Overview`) {
      history.push(`/v2/inventory-overview`);
    } else if (title === `Airport Transfer`) {
      history.push(`/v2/inventory-dashboard`);
    } else if (
      title === 'Airport List' ||
      title === 'Zone List' ||
      title === 'Vendor List' ||
      title === 'Client List' ||
      title === 'Configurations List'
    ) {
      setCurrentActiveBookingAction(null);
    }
  };

  useEffect(() => {
    if (
      bookingsListLoading ||
      inventoryViewLoading ||
      getDashboardConfigurationLoading ||
      cardSummaryCountLoading ||
      createAirportV2Loading ||
      createClientV2Loading ||
      createVendorV2Loading ||
      createZonesV2Loading ||
      updateAirportV2Loading ||
      updateClientV2Loading ||
      updateVendorV2Loading ||
      updateZonesV2Loading ||
      validateZoneLoading
    ) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [
    bookingsListLoading,
    inventoryViewLoading,
    getDashboardConfigurationLoading,
    cardSummaryCountLoading,
    createAirportV2Loading,
    createClientV2Loading,
    createVendorV2Loading,
    createZonesV2Loading,
    updateAirportV2Loading,
    updateClientV2Loading,
    updateVendorV2Loading,
    updateZonesV2Loading,
    validateZoneLoading,
  ]);

  return (
    <div className="page-content">
      {loading && <Loader zIndex={true} />}

      <Container fluid className="position-relative">
        {!currentActiveBookingAction && (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-1 align-items-center">
                <BreadcrumbTrail
                  title={title}
                  navigationby={breadcrumNavigationHandler}
                  navigation={['Management', 'Inventory', 'Overview', 'Airport Transfer', title]}
                />
              </div>

              <Filter filterHandler={filterSubmitHandler} />
            </div>

            <DataViews
              data={bookingsList}
              updateURLParams={updateURLParams}
              skip={currentPageNumber}
              limit={rowsPerPage}
              selectedBooking={currentSelectedBooking}
              setCurrentSelectedBooking={setCurrentSelectedBooking}
              setCurrentActiveBookingAction={setCurrentActiveBookingAction}
              titleText={title}
              appliedName={appliedName?.toString()}
              isMultiSelectable={isMultiSelectable}
              setIsMultiSelectable={setIsMultiSelectable}
              shouldHaveClearSelection={shouldHaveClearSelection}
              setShouldHaveClearSelection={setShouldHaveClearSelection}
              filterSubmitHandler={filterSubmitHandler}
              currentlyAppliedFilters={currentlyAppliedFilters}
              assignedToMeFilter={assignedToMeFilter}
              setAssignedToMeFilter={setAssignedToMeFilter}
              secondaryFiltersList={secondaryFiltersList}
            />

            {currentSelectedBooking?.length === 1 &&
              inventoryView &&
              (title === 'Configurations List' ? (
                <Summary2
                  details={inventoryView}
                  currentSelectedBooking={currentSelectedBooking?.[0]}
                  setCurrentSelectedBooking={setCurrentSelectedBooking}
                  setCurrentActiveBookingAction={setCurrentActiveBookingAction}
                  title={title}
                />
              ) : (
                <Summary details={inventoryView} currentSelectedBooking={currentSelectedBooking?.[0]} title={title} />
              ))}
          </>
        )}

        {currentActiveBookingAction && (
          <>
            <div className="d-flex gap-1 align-items-center">
              <BreadcrumbTrail
                title={title}
                navigationby={breadcrumNavigationHandler}
                navigation={[`Management`, 'Inventory', 'Overview', 'Airport Transfer', title, `Add ${title.toString().split(' ')?.[0]}`]}
              />
            </div>

            <InventoryActions
              setCurrentActiveBookingAction={setCurrentActiveBookingAction}
              currentSelectedInventory={currentSelectedBooking}
              currentActiveBookingAction={currentActiveBookingAction}
            />
          </>
        )}
      </Container>
    </div>
  );
};

export default InventoryList;
